"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
const AndroidDownload_1 = __importDefault(require("./AndroidDownload"));
const AppStoreDownload_1 = __importDefault(require("./AppStoreDownload"));
const PlayStoreDownload_1 = __importDefault(require("./PlayStoreDownload"));
const ChromeDownload_1 = __importDefault(require("./ChromeDownload"));
const FirefoxDownload_1 = __importDefault(require("./FirefoxDownload"));
const Windows_1 = __importDefault(require("../IconsSystems/Windows"));
const Apple_1 = __importDefault(require("../IconsSystems/Apple"));
const Linux_1 = __importDefault(require("../IconsSystems/Linux"));
const Android_1 = __importDefault(require("../IconsSystems/Android"));
var Types;
(function (Types) {
    Types["AppStore"] = "ios";
    Types["PlayStore"] = "google";
    Types["Android"] = "android";
    Types["Windows"] = "windows";
    Types["Apple"] = "apple";
    Types["Linux"] = "linux";
    Types["Apk"] = "apk";
    Types["Chrome"] = "chrome";
    Types["Firefox"] = "firefox";
})(Types = exports.Types || (exports.Types = {}));
/**
 * Download icons for different app stores.
 */
const Download = (_a) => {
    var { type = Types.AppStore, link, width, height } = _a, rest = __rest(_a, ["type", "link", "width", "height"]);
    return (react_1.default.createElement(styled_1.Wrapper, Object.assign({ href: link, target: "_blank", rel: "noopener noreferrer" }, rest, { "aria-label": `Download via the ${type} store` }),
        type === Types.AppStore && react_1.default.createElement(AppStoreDownload_1.default, { width: width, height: height }),
        type === Types.PlayStore && react_1.default.createElement(PlayStoreDownload_1.default, { width: width, height: height }),
        type === Types.Android && react_1.default.createElement(AndroidDownload_1.default, null),
        type === Types.Windows && react_1.default.createElement(Windows_1.default, null),
        type === Types.Apple && react_1.default.createElement(Apple_1.default, null),
        type === Types.Linux && react_1.default.createElement(Linux_1.default, null),
        type === Types.Apk && react_1.default.createElement(Android_1.default, null),
        type === Types.Chrome && react_1.default.createElement(ChromeDownload_1.default, null),
        type === Types.Firefox && react_1.default.createElement(FirefoxDownload_1.default, null)));
};
Download.Types = Types;
exports.default = Download;
//# sourceMappingURL=Download.js.map